import { useDisclosure } from '@chakra-ui/react';
import CustomDialog from '../CustomDialog/CustomDialog';
import type { PropsWithChildren } from 'react';
import { Form, type FormProviderProps } from '@packages/chakra-v3';

type FormDialogProps<T> = {
	trigger: React.ReactNode;
	header: {
		title: string;
	};
	onSubmit: (data: T) => void;
} & PropsWithChildren & Omit<FormProviderProps<T>, 'children'>;

const FormDialog = <T extends Record<string, unknown>>({
	trigger, children, header, onSubmit, ...formProviderProps
}: FormDialogProps<T>) => {
	const { open, setOpen } = useDisclosure();
	const handleSubmit = (data: T) => {
		onSubmit(data);
		setOpen(false);
	};

	return (
		<CustomDialog.Root open={open} onOpenChange={e => setOpen(e.open)}>
			<CustomDialog.Trigger>
				{trigger}
			</CustomDialog.Trigger>
			<CustomDialog.Portal>
				<Form.Provider<T> {...formProviderProps} onSubmit={handleSubmit}>
					<CustomDialog.Content>
						<CustomDialog.Header title={header.title} />
						{children}
					</CustomDialog.Content>
				</Form.Provider>
			</CustomDialog.Portal>
		</CustomDialog.Root>
	);
};

FormDialog.Header = CustomDialog.Header;
FormDialog.Body = CustomDialog.Body;
FormDialog.Footer = CustomDialog.Footer;

export default FormDialog;